export default "__VITE_ASSET__CBK$Yeoz__"